import React from 'react';
import ReactDOM from 'react-dom';
import { usePortalContainer } from '../../hooks';
import { ThemeProvider } from '../theme';
import { useThemeContext } from '../theme/useThemeContext';
import { block } from '../utils/cn';
import './Portal.css';
const b = block('portal');
export function Portal({ container, children, disablePortal }) {
    const defaultContainer = usePortalContainer();
    const { scoped } = useThemeContext();
    const containerNode = container !== null && container !== void 0 ? container : defaultContainer;
    if (disablePortal) {
        return React.createElement(React.Fragment, null, children);
    }
    return containerNode
        ? ReactDOM.createPortal(scoped ? (React.createElement(ThemeProvider, { rootClassName: b('theme-wrapper'), scoped: true }, children)) : (children), containerNode)
        : null;
}
